import axios from 'axios'
import { getAccessToken, getRefreshTokenCookie, setRefreshTokenCookie, setAccessToken, removeAccessToken, removeRefreshTokenCookie } from './auth';
import jwt_decode from "jwt-decode";

class Api {
    constructor(){
        this.isRefreshing = false;
        this.refreshSubscribers = [];
        this.failedQueue = [];
        this.REFRESH_TOKEN_HEADER_ENDPOINTS = ['/admin/refreshtoken', '/admin/logout']
        this.initializeRequestInterceptor();
        this.initializeResponseInterceptor();
    }
    getBaseURL = (params, url) => {
        let baseUrl;
        baseUrl = process.env.REACT_APP_API_URL;
        // let instaReportLinks = ["/instaEngagement", "/missionLinkEngagement", "/instagramVisionForStory"];
        // if (params._vortex) {
        //     baseUrl = process.env.REACT_APP_API_URL_VORTEX;
        //     // baseUrl = "https://dev.frapp.in";
        //     // baseUrl = "https://vortex.frapp.in";
        // }
        // if (instaReportLinks.indexOf(url) >= 0) {
        //     baseUrl = process.env.REACT_APP_API_URL_INSTASCRAPER;
        // } else {
        //     baseUrl = process.env.REACT_APP_API_URL;
        //     // baseUrl = "http://54.169.233.100:1441";
        //     // baseUrl = "https://backbone.frapp.in";
        // }

        return baseUrl;
    }

    initializeRequestInterceptor(){
        axios.interceptors.request.use((config) => {
            
            const isCallWithRefreshToken = this.REFRESH_TOKEN_HEADER_ENDPOINTS.some(endpoint =>
                config.url.includes(endpoint)
            );
            if (isCallWithRefreshToken) {
                // Set custom headers just for refresh token call
                // config.headers['X-Refresh-Token'] = 'true';
                // Don't send the normal access token
                delete config.headers['Authorization'];
            }else{
                const token = window.localStorage.token;
                if (token) {
                    config.headers.Authorization = `token ${token}`
                }
            }
            // spinning start to show
            // UPDATE: Add this code to show global loading indicator
            // document.body.classList.add('loading-indicator');
            return config
        },
        (error) => {
            return Promise.reject(error);
        });
    }

    initializeResponseInterceptor = () => {
        axios.interceptors.response.use((response) => {
            return response
        },
        async (err) => {
        const originalRequest = err.config;
    
      // Prevent infinite loop if refresh API itself fails
      if (originalRequest.url.includes('/admin/refreshtoken')) {
        return Promise.reject(err); // Skip refresh retry if it's the refresh call itself
      }

        if(err && err.response.status === 401 && !originalRequest._retry){
            originalRequest._retry = true;


            if (this.isRefreshing) {
                try {
                    const token = await new Promise((resolve, reject) => {
                        this.failedQueue.push({ resolve, reject });
                    });
                        // ✅ Only retry if token is actually valid
                    if (!token) throw new Error('No token returned from queue');
                    originalRequest.headers['Authorization'] = `Bearer ${token}`;
                    const updatedtoken = getAccessToken();
                    if (updatedtoken) {
                        originalRequest.headers.Authorization = `Bearer ${updatedtoken}`
                    }
                    return await axios(originalRequest);
                } catch (err_1) {
                    console.log(err_1)
                    return await Promise.reject(err_1);
                }
              }

               // First time handling the refresh
              this.isRefreshing = true;

              return new Promise(async (resolve, reject) => {
                try {
                  const refreshToken = getRefreshTokenCookie();
        
                  if (!refreshToken) throw new Error('No refresh token available');
          
                  const res = await axios.get(`${this.getBaseURL()}/admin/refreshtoken`, {
                    headers: {
                      'x-authorization-refresh-token': refreshToken
                    }
                  });
                   // 👇 This ensures catch block is reached if refresh fails silently
                    if (res.status === 401) {
                        throw { response: { status: 401, data: 'Unauthorized refresh' } };
                    }
                  const headers = res.headers
                  const newAccessToken = headers["x-authorization-token"];
                  const roleDecodeFromNewAccessToken = jwt_decode(newAccessToken).auth
                  const roleDecodeFromOldAccessToken = jwt_decode(localStorage.authToken).auth
                  if(roleDecodeFromNewAccessToken !== roleDecodeFromOldAccessToken){
                        alert("Your role has been changed, please wait as we update the control..")
                        setTimeout(() => {
                            window.location.reload()
                        }, 500);
                  }
                  localStorage.setItem('authToken', newAccessToken)
                    
                  if(headers["x-authorization-refresh-token"]) setRefreshTokenCookie(headers["x-authorization-refresh-token"]);
                  this.processQueue(null, newAccessToken);
                  originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                  resolve(axios(originalRequest));
                } catch (refreshError) {
                  this.processQueue(refreshError, null);
                  removeAccessToken();
                  removeRefreshTokenCookie();
                  if (refreshError.response.status === 401) {
                    window.location.href = '/'; // optional: redirect user to login
                  }
                  reject(refreshError); // This ensures .catch() is triggered
                } finally {
                  this.isRefreshing = false;
                }
              })
        }
    
        return Promise.reject(err);  
    
    })
    }
    processQueue(error, token = null) {
        this.failedQueue.forEach((prom) => {
            if (error) {
              prom.reject(error);
            } else {
              prom.resolve(token);
            }
          });
        this.failedQueue = [];
    }

    addAuth = (params) => {
        var tokenVar = 'authToken'
        // var tokenVar = params._vortex ? 'authTokenVortex' : 'authToken';
        var token = localStorage.getItem(tokenVar);
        // token = "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJiYXNlIjoiNWM2MTRlMjZjOTM5NGUwMDE2YWNiMDhkIiwiaWF0IjoxNTUwNDg0OTIyLCJleHAiOjE1NTE2OTQ1MjJ9.avKdWpeKidnlACs-QIHk2Se8vPaY1sCOdSYekhOMlrjKjC-oW712nzHMBAN3Dvzsf03WheOuk8AN5-IzIXouyQ";
        var headers = {
            'Authorization': `Bearer ${token}`
        }
        headers = params && params.public ? {} : headers;

        return localStorage.getItem('authToken') ? headers : {};
    }

    addRefreshAuth = (refreshToken) => {
        const headers = {
            'x-authorization-refresh-token': refreshToken
        }
        return headers
    }

    addParams = (params, url) => {
        let fileUploadLinks = ["/teletask/uploadTeleTasks", "/teletask/uploadcsvtosqs", "refreshertraining/uploadvideo", "teletask/transferLeadsByIds", "telecaller/bulkmatchtelecaller",
            "/telecaller/bulkupdateearnings", "/telecaller/bulkcertifycallers", "/telecaller/bulkaddofferletters", "/telecaller/bulkmatchtelecaller", "/telecaller/bulkmoderation",
            "/teletask/alpleadstransferbyuserids"
        ];
        if (fileUploadLinks.includes(url)) {  /// BECAUSE IT'S FORM DATA AND YOU DON'T WANA MESS WITH IT 


            return params
        } else {
            var newParams = Object.assign({}, params);
            if (params) {
                try {
                    delete newParams.public;
                    delete newParams.infinite;
                    delete newParams.fullResponse;
                    delete newParams._vortex;
                    delete newParams._getFullResponse
                } catch (err) {
                    // do nothing
                }
            }

            return newParams;

        }
    }

    get = (url, params, refreshToken = '') => {
        params = params || {};

        var promise = axios({
            url: `${url}`,
            method: 'get',
            baseURL: this.getBaseURL(params),
            headers: refreshToken ? this.addRefreshAuth(refreshToken) : this.addAuth(params),
            params: this.addParams(params)
        })

        if (params._getFullResponse) {
            return promise
        }
        return promise
            .then((resp) => resp.data)
            .catch(err => { console.log(err); throw err })


    }

    getStream = (url, params) => {
        var promise = axios({
            url: `${url}`,
            method: 'get',
            baseURL: this.getBaseURL(params),
            responseType: 'stream',
            params: this.addParams(params),
            headers: this.addAuth(params)
        })


        return promise
    }

    post = (url, data) => {
        return axios({
            url: `${url}`,
            method: 'post',
            baseURL: this.getBaseURL(data, url),
            data: this.addParams(data, url),
            headers: this.addAuth(data)
        })
    }

    put = (url, data) => {
        return axios({
            url: `${url}`,
            method: 'put',
            baseURL: this.getBaseURL(data),
            data: this.addParams(data),
            headers: this.addAuth(data)
        })
    }

    delete = (url, data) => {
        return axios({
            url: `${url}`,
            method: 'delete',
            baseURL: this.getBaseURL(data),
            data: data,
            headers: this.addAuth(data)
        })
    }




    // Freshdesk [ FD ] Requests
    addParams_freshdesk = (data) => {
        return JSON.stringify(data)
    }

    addAuth_freshdesk = () => {
        let username = process.env.REACT_APP_API_KEY_FRESHDESK;
        // let username = 'Y9qob1FHazXMnqKAp5m';
        let password = 'X'

        const token = `${username}:${password}`;
        const encodedToken = Buffer.from(token).toString('base64');

        if(localStorage.getItem('authToken')) {
            return { 
                'Authorization': 'Basic '+ encodedToken,
                'Content-Type': 'application/json',
                // 'Cookie': '_x_m=x_c; _x_w=2'
            }
        }
        else {
            return {}
        }

    }

    post_freshdesk = (url,data) => {
        let baseURL = process.env.REACT_APP_API_URL_FRESHDESK
        return axios({
            method: 'post',
            url: `${url}`,
            baseURL: baseURL,
            // baseURL: "https://newaccount1623918089734.freshdesk.com/api/v2",
            data: this.addParams_freshdesk(data),
            headers: this.addAuth_freshdesk()
        })
    }

    handleError = async(error) => {
        const originalRequest = error.config;
    }
}


   

// function handleRefreshToken(){
//     var user = JSON.parse(localStorage.getItem("user"));
//     var {refreshToken} = user;

//     var api = new Api();
//     api.get(`/user/refreshAccessToken`,{refreshToken})
//     .then(resp => {
//         var data = resp.data;
//         user.token = data.token;

//         debugger
//         window.location.reload();
//         localStorage.setItem("user",data.token)
//         localStorage.setItem("authToken",data.refreshToken)

//     })
//     .catch(err => {
//         console.log(err)
//     })

//     debugger
// }

// function getBrowserSpecs(type){
//     var ua = navigator.userAgent, tem, 
//     M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
//     if(/trident/i.test(M[1])){
//         tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
//         return {name:'IE',version:(tem[1] || '')};
//     }
//     if(M[1]=== 'Chrome'){
//         tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
//         if(tem != null) return {name:tem[1].replace('OPR', 'Opera'),version:tem[2]};
//     }
//     M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
//     if((tem = ua.match(/version\/(\d+)/i))!= null)
//         M.splice(1, 1, tem[1]);

//     return type === "name" ? M[0] : M[1];
// }

export default new Api()